import type { TargetingCondition, TargetingDiff, TargetingGroup } from 'helpers/targeting-identity';
import { TARGETING_GROUP_ORDER } from 'helpers/targeting-identity';
import { ConditionChips } from './ConditionChips';

const GROUP_LABEL: Record<TargetingGroup, string> = {
  device: 'Device',
  url: 'URL',
  cookie: 'Cookie',
  activation: 'Activation',
};

type RowProps = { label: string; children: React.ReactNode };

const Row = ({ label, children }: RowProps) => (
  <div className="grid grid-cols-[6rem_1fr] items-start gap-3">
    <span className="supporting pt-0.5">{label}</span>
    {children}
  </div>
);

type DiffRowsProps = { diff: TargetingDiff; showKeeps: boolean };

/** Adds, Removes and (when asked) Keeps, each only if it has something in it. */
export const DiffRows = ({ diff, showKeeps }: DiffRowsProps) => (
  <div className="flex flex-col gap-2">
    {diff.removes.length ? (
      <Row label="Removes">
        <ConditionChips conditions={diff.removes} tone="remove" />
      </Row>
    ) : null}
    {diff.adds.length ? (
      <Row label="Adds">
        <ConditionChips conditions={diff.adds} tone="add" />
      </Row>
    ) : null}
    {showKeeps && diff.keeps.length ? (
      <Row label="Keeps">
        <ConditionChips conditions={diff.keeps} />
      </Row>
    ) : null}
  </div>
);

type GroupRowsProps = { conditions: readonly TargetingCondition[] };

/** The conditions grouped by kind, one row per kind that has any: what a save will store. */
export const GroupRows = ({ conditions }: GroupRowsProps) => (
  <div className="flex flex-col gap-2">
    {TARGETING_GROUP_ORDER.map((group) => {
      const inGroup = conditions.filter((condition) => condition.group === group);
      return inGroup.length ? (
        <Row key={group} label={GROUP_LABEL[group]}>
          <ConditionChips conditions={inGroup} />
        </Row>
      ) : null;
    })}
  </div>
);
